<template>
  <div class="container-fluid py-4 px-4">


    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-clipboard-data display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            REPORTE
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTADO DE REPORTES
          </p>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <div class="col-12 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">
          <div class=" align-items-center">

            <div class="d-flex justify-content-between align-items-center">
              <i class="bi bi-filetype-xls text-success display-6"></i>

              <div>
                <button class="btn btn-success px-3 py-2 shadow-sm rounded-3" @click="descargarExcelAsistencia()">
                  <i class="bi bi-download "></i>
                </button>

              </div>
            </div>

            <div>
              <h5 class="mt-3 mb-2 card-title">Registro de Asistencia por Periodo</h5>

              <p class="mb-0">
                Descarga el archivo Excel por periodo con todas las asistencias registradas.
              </p>

              <!-- SWITCH -->

              <!-- Empresa -->
              
                <select  class="form-select tamaños mt-2"  @change="Empresa($event)">
                  <option selected disabled>--Seleccionar empresa--</option>
                  <option v-for="empresas in DniEmpre" :key="empresas.id" :value="empresas.id">
                    {{ empresas.empRazSocial }}
                  </option>
                </select>
              
              <!-- Centro Costos -->
             <select v-if="idUsuario ==3196" class="form-select tamaños mt-2"  @change="CostosEvent($event)">
                  <option selected disabled>--Seleccionar Centro Costo--</option>
                  <option v-for="CentroCostes in CentroCoste" :key="CentroCostes.id" :value="CentroCostes.cenCodigo">
                    {{ CentroCostes.cenNombre }}
                  </option>
                </select>

            
                <select  class="form-select tamaños mt-2" @change="SubCostros($event)">
                  <option selected disabled>--Seleccionar SubCentro--</option>
                  <option v-for="scc in SubCentroCoste" :key="scc.id" :value="scc.cenSubCentro">
                    {{ scc.cenNombre }}
                  </option>
                </select>

            

            
              <div class="mt-2">
                <select v-model="mes" id="mesAsistencia" class="form-select mb-2">
                  <option value="" disabled>-- SELECCIONAR MES --</option>
                  <option value="1">ENERO</option>
                  <option value="2">FEBRERO</option>
                  <option value="3">MARZO</option>
                  <option value="4">ABRIL</option>
                  <option value="5">MAYO</option>
                  <option value="6">JUNIO</option>
                  <option value="7">JULIO</option>
                  <option value="8">AGOSTO</option>
                  <option value="9">SEPTIEMBRE</option>
                  <option value="10">OCTUBRE</option>
                  <option value="11">NOVIEMBRE</option>
                  <option value="12">DICIEMBRE</option>
                </select>

                <select v-model="anio" id="anioAsistencia" class="form-select mb-3">
                  <option disabled value="">SELECCIONA EL AÑO</option>
                  <option v-for="y in anios" :key="y" :value="y">
                    {{ y }}
                  </option>
                </select>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">

          <div class="align-items-center">

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-between align-items-center">
                <i class="bi bi-filetype-xls text-success display-6"></i>
              </div>
              <div>
                <button class="btn btn-success px-3 py-2 shadow-sm rounded-3" :disabled="ExcelReport"
                  @click="descargarReporte()">
                  <i class="bi bi-download "></i>
                </button>
              </div>
            </div>

            <div>
              <h4 class="mt-3 mb-2 card-title">Reporte de Actividad</h4>

              <p class="mb-0">
                Selecciona el mes para descargar el reporte de actividad.
              </p>

              <!-- <label class="google-switch mt-1">
                                <input type="checkbox" v-model="activarReportesPeriodo">
                                <span class="google-slider"></span>
                            </label> -->
            </div>

          </div>

          <div class="mt-4">
            {{ mes1 }}
            <select v-model="mes1" id="mesActividad" class="form-select">
              <option selected disabled value="">SELECCIONAR UN MES</option>
              <option value="1">ENERO</option>
              <option value="2">FEBRERO</option>
              <option value="3">MARZO</option>
              <option value="4">ABRIL</option>
              <option value="5">MAYO</option>
              <option value="6">JUNIO</option>
              <option value="7">JULIO</option>
              <option value="8">AGOSTO</option>
              <option value="9">SEPTIEMBRE</option>
              <option value="10">OCTUBRE</option>
              <option value="11">NOVIEMBRE</option>
              <option value="12">DICIEMBRE</option>
            </select>
          </div>
        </div>
      </div>

      <!-- nuevo resporte -->
      <div class="col-12 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">

          <div class="align-items-center">

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-between align-items-center">
                <i class="bi bi-filetype-xls text-success display-6"></i>
              </div>
              <div>
                <button class="btn btn-success px-3 py-2 shadow-sm rounded-3" @click="reporteInventario()">
                  <i class="bi bi-download "></i>
                </button>
              </div>
            </div>

            <div>
              <h4 class="mt-3 mb-2 card-title">Reporte de Inventario</h4>

              <p class="mb-0">
                Descargar Reporte total del inventario
              </p>
              
              <div class="mt-5">
               <input v-model="fecSolicitada" type="date" class="form-control form-control-sm" />

              </div>
              <!-- <label class="google-switch mt-1">
                                <input type="checkbox" v-model="activarReportesPeriodo">
                                <span class="google-slider"></span>
                            </label> -->
            </div>

          </div>

          <!-- <div class="mt-4">
            {{ mes1 }}
            <select v-model="mes1" id="mesActividad" class="form-select">
              <option selected disabled value="">SELECCIONAR UN MES</option>
              <option value="1">ENERO</option>
              <option value="2">FEBRERO</option>
              <option value="3">MARZO</option>
              <option value="4">ABRIL</option>
              <option value="5">MAYO</option>
              <option value="6">JUNIO</option>
              <option value="7">JULIO</option>
              <option value="8">AGOSTO</option>
              <option value="9">SEPTIEMBRE</option>
              <option value="10">OCTUBRE</option>
              <option value="11">NOVIEMBRE</option>
              <option value="12">DICIEMBRE</option>
            </select>


          </div> -->
        </div>
      </div>

       <div class="col-12 col-lg-3 d-flex">
        <div class="card h-100 shadow-sm border-2 p-4 rounded-4 card-cuadrada">

          <div class="align-items-center">

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-between align-items-center">
                <i class="bi bi-filetype-xls text-success display-6"></i>
              </div>
              <div>
                <button class="btn btn-success px-3 py-2 shadow-sm rounded-3" 
                 @click="reporteInventarioxtienda()">
                  <i class="bi bi-download "></i>
                </button>
              </div>
            </div>

            <div>
              <h4 class="mt-3 mb-2 card-title">Reporte de Inventario por tienda</h4>

              <p class="mb-0">
                Descargar reporte Diario del inventario.
              </p>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters } from "vuex";
import Swal from 'sweetalert2';
export default {
  name: "SolimanologControlDeAsistencia",

  data() {
    return {
      idTrabajador: null,
      mes: "", // Variable mes
      mes1: "",
      anio: new Date().getFullYear(),
      ExcelReport: false,
      fecSolicitada:"",
      form: {
        idEmpresa: "0",
        codCentro: "0",
        codScc: "",
        codSscc: "",
      },
      CentroCoste: [],
      SubCentroCoste: [],

      selectedEmpresaId: null,
      selectedCentroCostoId: null,
      selectedSubCentroId: null,
      idUsuario: null,
    };
  },

  created() {
    this.idUsuario = localStorage.getItem("userId");
    this.idTrabajador = localStorage.getItem("idTrabajdor");
    this.cambiarEstadoNavbar();

  },
  computed: {
        ...mapGetters("users", ["DniEmpre"]),

    anios() {
      const inicio = 2023; // ← año desde donde empieza tu sistema
      const actual = new Date().getFullYear();

      return Array.from(
        { length: actual - inicio + 1 },
        (_, i) => inicio + i
      );
    }
  },

  methods: {
    cambiarEstadoNavbar() {
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    descargarExcelAsistencia() {
      this.idTrabajador = localStorage.getItem("idTrabajdor");

      if (this.mes && this.anio) { // Verifica que se haya seleccionado un mes y año
        this.axios
          .get(
            `ReportesExcel/ReporteAsistencia?idTrabajador=${this.idTrabajador}&mes=${this.mes}&anio=${this.anio}&idEmpresa=${this.form.idEmpresa}&CentroCosto=${this.cenCodigoCentro}&SubCentroCosto=${this.CodigoSubCentro}`,
            { responseType: "blob" }
          )
          .then((response) => {
            const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `ReporteAsistencia_${this.mes}_${this.anio}.xlsx`; // Nombre del archivo con mes y año
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((error) => {
            console.error("Error al descargar el archivo Excel de Asistencia:", error);
          });
      } else {
        alert("Por favor seleccione un mes y un año.");
      }
    },

    async cargarReporteActividad() {
      this.idTrabajador = localStorage.getItem("idTrabajdor");
      console.log(this.mes1)
      //   if (this.mes1) { // Verifica que se haya seleccionado un mes
      //     this.axios
      //       .get(`ReportesExcel/ReporteActividadMensual?mes=${this.mes1}&idTrabajador=${this.idTrabajador}`, { responseType: "blob" })
      //       .then((response) => {
      //         const blob = new Blob([response.data], {
      //           type: "application/zip", // Cambio de tipo a ZIP
      //         });

      //         const link = document.createElement("a");
      //         link.href = window.URL.createObjectURL(blob);
      //         link.download = `ReporteActividadSinFoto_${this.mes}.zip`; // Se cambia la extensión a .zip
      //         document.body.appendChild(link);
      //         link.click();
      //         document.body.removeChild(link);
      //       })
      //       .catch((error) => {
      //         console.error("Error al descargar el archivo ZIP del Reporte de Actividadessssss:", error);
      //       });
      //   } else {
      //     alert('Por favor seleccione un mes.');
      //   }

      if (!this.mes1) {
        Swal.fire("Atención", "Por favor, seleccione un mes", "warning");
        return;
      }

      try {
        // Mostramos un spinner o alerta de carga
        Swal.fire({
          title: 'Generando Excel...',
          text: 'Por favor espere',
          allowOutsideClick: false,
          didOpen: () => { Swal.showLoading(); }
        });

        const response = await this.axios.get("ReportesExcel/ReporteActividadMensual", {
          params: {
            mes: this.mes1,
            idTrabajador: this.idTrabajador // El ID que obtuviste al validar el DNI
          },
          responseType: 'blob' // <--- VITAL: Indica que recibimos un archivo binario
        });

        // Crear un link temporal para la descarga
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Nombre del archivo al descargar
        const nombreArchivo = `Reporte_Actividades_Mes_${this.mes1}.xlsx`;
        link.setAttribute('download', nombreArchivo);

        document.body.appendChild(link);
        link.click();

        // Limpieza
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        Swal.close(); // Cerramos el loading

      } catch (error) {
        console.error("Error al descargar:", error);
        Swal.fire("Error", "No se pudo generar el reporte", "error");
      }


    },

    ReporteActividadFoto() {
      this.idTrabajador = localStorage.getItem("idTrabajdor");

      if (this.mes) { // Verifica que se haya seleccionado un mes
        this.axios
          .get(`ReportesExcel/GenerarReportesPorMes?mes=${this.mes}&idTrabajadores=${this.idTrabajador}`, { responseType: "blob" })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: "application/zip", // Cambio de tipo a ZIP
            });

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `ReporteActividadConFoto_${this.mes}.zip`; // Se cambia la extensión a .zip
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((error) => {
            console.error("Error al descargar el archivo ZIP del Reporte de Actividades:", error);
          });
      } else {
        alert('Por favor seleccione un mes.');
      }
    },

    reporteInventario() {
      this.axios
        .get("ReportesExcel/ReporteInventario", {
          params: { fecha: this.fecSolicitada },
          responseType: "blob"
        })
        .then((response) => {
          const blob = new Blob(
            [response.data],
            { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
          );

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute(
            "download",
            `Reporte_Inventario_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '_')}.xlsx`
          );

          document.body.appendChild(link);
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Error descargando el reporte:", error);
        });
    },

reporteInventarioxtienda(){
this.axios
    .get("ReportesExcel/ReporteInventarioResumenTiendas", {
      responseType: "blob"
    })
    .then((response) => {
      const blob = new Blob(
        [response.data],
        { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
      );

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute(
        "download",
        `Reporte_Inventario_${new Date().toISOString().slice(0,19).replace(/[:T]/g,'_')}.xlsx`
      );

      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    })
    .catch((error) => {
      console.error("Error descargando el reporte:", error);
    });
},

    // Método para descargar el reporte de actividades
    descargarReporte() {
      // Obtener y convertir idTrabajador a número
      // const idTrabajador = parseInt(localStorage.getItem("idTrabajdor"), 10);

      // const idsConFoto = [601, 10953, 11870];
      // console.log("llegue aqui")
      // if (idsConFoto.includes(idTrabajador)) {
      //   this.ReporteActividadFoto();
      // } else {
      this.cargarReporteActividad();
      // }
    },


 Empresa(event) {
      this.form.idEmpresa = event.target.value;

      console.log(this.form.idEmpresa);


      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${localStorage.getItem("dniUsers")}`
        )
        .then((r) => {
          this.CentroCoste = r.data;
          if(this.idTrabajador != 474){
             this.CostosEvent(event)
          }
        });
    },

     CostosEvent(event) {
      
      console.log(this.idTrabajador)
      if(this.idTrabajador != 474){
      this.cenCodigoCentro= '01'
      }else{
        this.cenCodigoCentro= event.target.value
      }
      console.log(this.cenCodigoCentro)
      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${this.cenCodigoCentro}&dniUser=${localStorage.getItem("dniUsers")}&idEmpresa=${this.form.idEmpresa}`
        )
        .then((r) => {
          this.SubCentroCoste = r.data;
          console.log(this.SubCentroCoste)
        });
    },

    SubCostros(event) {
      console.log(event.target.value);
      this.CodigoSubCentro = event.target.value;
      // this.axios
      //   .get(`SubSubCentro/ObtenerSubCentro/${event.target.value}`)
      //   .then((r) => {
      //     this.SubSubCentroCoste = r.data;
      //   });

      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.form.idEmpresa}&dniUser=${localStorage.getItem("dniUsers")}&codCentro=${this.cenCodigoCentro}&codSubCentro=${event.target.value}`
        )
        .then((r) => {
          this.SubSubCentroCoste = r.data;
          console.log(r.data);
        });
    },

   

  },
};
</script>


<style scoped>
.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.reducirTamaño {
  font-size: 0.65rem;
}

.card-cuadrada {
  border-radius: 0 !important;

  border: 1px solid #e5e5e5 !important;
}
</style>
